import * as React from "react"
import { Widget, mk_widget } from "widgets-for-react"
import { StyleguideImgPlaceholder } from "../helpers"
import { gridItem } from "../object/gridItem"

export const compositionVideoLibrary: Widget<never> = mk_widget({
  run: (_) => (
    <section className="block block--library">
      <div className="block__inner container container--l grid--block">
        {videoHighlights('title', 'intro')}
        <div className="filters">
          <span className="sr-text">Tags van videos</span>
          <ul className="filters__list">
            {videoFilter("Alle video's", true)}
            {videoFilter("Thema 1", false)}
            {videoFilter("Thema 2", false)}
            <li className="filter">
              <button className="filter__button btn btn--primary">
                <span>Filters</span>
              </button>
            </li>
          </ul>
        </div>
        <ul className="block__grid grid c--columns">
          {gridItem({ hasLink: true, hasImage: true, inner: { hasLink: true, hasImage: true, hasDate: false } })}
          {gridItem({ hasLink: true, hasImage: true, inner: { hasLink: true, hasImage: true, hasDate: false } })}
          {gridItem({ hasLink: true, hasImage: true, inner: { hasLink: true, hasImage: true, hasDate: false } })}
          {gridItem({ hasLink: true, hasImage: true, inner: { hasLink: true, hasImage: true, hasDate: false } })}
          {gridItem({ hasLink: true, hasImage: true, inner: { hasLink: true, hasImage: true, hasDate: false } })}
          {gridItem({ hasLink: true, hasImage: true, inner: { hasLink: true, hasImage: true, hasDate: false } })}
        </ul>
      </div>
    </section>
  ),
})

export const videoFilter = (tag: string, active: boolean) => {
  return (
    <li className="filter">
      <label className={`filter__tag btn btn--tertiary${active === true ? " btn--active" : ""}`} htmlFor={tag}>
        <input type="checkbox" className="filter__checkbox" id={tag} />
        {tag}
      </label>
    </li>
  )
}

export const videoHighlights = (title: string, intro: string) => {
  return (
    <div className="block__highlight highlight">
      <div className="highlight__inner">
        <header className="highlight__header item--2">
          <h2 className="block__title highlight__title typo--l">{title}</h2>
          <p className="highlight__intro text--styled">
            <p>{intro}</p>
          </p>
        </header>
        <div className="highlight__visual item--1">
          <img
            className="highlight__image"
            src={StyleguideImgPlaceholder({
              shape: { width: 580, height: 440, radius: "0", bgColor: "#9CD1C2" },
              text: { color: "#1e1e1e", font: "Open Sans, sans-serif" },
            })}
            width="580"
            height="440"
            alt="Add alt text"
          />
        </div>
      </div>
    </div>
  )
}

export const compositionOverlayVideoLibrary: Widget<never> = mk_widget({
  run: (_) => (
    <>
      <div className="lightbox--open">
        <div className="lightbox">
          <div className="lightbox__inner container container--m grid--block">
              <button className="lightbox__close close">
                <span className="close__label sr-text">Close overlay</span>
                <svg className="close__icon" aria-hidden="true" width="14" height="14">
                  <use xlinkHref="#icon--close"></use>
                </svg>
              </button>
            <figure className="lightbox__figure">
              {/* the svg is a Placeholder for video: 
              the video wrapper will need to have the classname "lightbox__video" */}
              <div className="lightbox__video"></div>
            </figure>
          </div>
        </div>
      </div>
    </>
  ),
})



// WEBPACK FOOTER //
// ./Client/styleguide/components/compositions/videoLibrary.tsx